import React from 'react';
import { PlayIcon, FileTextIcon, VideoIcon } from 'lucide-react';
import { motion } from 'framer-motion';
const steps = [{
  icon: PlayIcon,
  number: '1',
  title: 'Watch this video',
  description: "Meet our culture, values, and the work. Understand what we're building and who we're looking for."
}, {
  icon: FileTextIcon,
  number: '2',
  title: 'Fill out the application',
  description: "Complete a short form to tell us about yourself, your background, and why you're interested."
}, {
  icon: VideoIcon,
  number: '3',
  title: 'Record your video response',
  description: "Answer one question from Brock. We're looking for presence, confidence, and effort — not perfection."
}];
export function InterviewProcess() {
  const scrollToVideo = () => {
    document.getElementById('vsl-video')?.scrollIntoView({
      behavior: 'smooth',
      block: 'center'
    });
  };
  return <section id="apply" className="py-20 bg-off-white" data-id="element-87">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-88">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-89">
          <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl text-charcoal mb-4" data-id="element-90">
            How the interview works
          </h2>
          <p className="text-xl text-gray-700" data-id="element-91">
            Three simple steps. No games, no endless rounds.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-8 mb-12" data-id="element-92">
          {steps.map((step, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-white rounded-xl p-8 shadow-sm border border-gray-200" data-id="element-93">
              <div className="w-16 h-16 bg-maroon rounded-xl flex items-center justify-center mb-6" data-id="element-94">
                <step.icon className="w-8 h-8 text-white" data-id="element-95" />
              </div>
              <div className="font-display text-5xl text-maroon mb-3" data-id="element-96">
                {step.number}
              </div>
              <h3 className="text-xl font-bold text-charcoal mb-3" data-id="element-97">
                {step.title}
              </h3>
              <p className="text-gray-600 leading-relaxed" data-id="element-98">
                {step.description}
              </p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} className="text-center" data-id="element-99">
          <p className="text-gray-600 mb-8 italic" data-id="element-100">
            We don't expect perfect. We're looking for presence, confidence, and
            effort.
          </p>
          <button onClick={scrollToVideo} className="px-10 py-4 bg-maroon text-white font-bold text-lg rounded hover:bg-opacity-90 transition-colors inline-flex items-center space-x-2" data-id="element-101">
            <span data-id="element-102">Finish video to see apply link</span>
          </button>
          <p className="mt-4 text-sm text-gray-500 italic" data-id="element-103">
            The application link is revealed at the end of Brock's video.
          </p>
        </motion.div>
      </div>
    </section>;
}